import * as React from 'react';
import {Draggable} from 'react-beautiful-dnd';

import type {SalesAutomationStage as SalesAutomationStageFragment} from 'nutshell-graphql-types';

import {StageChevronContainer} from '../../stage-chevron-container';

type Props = {
    stage: SalesAutomationStageFragment;
    isFirstChild: boolean;
    isLastChild: boolean;
    onClick?: (stageId: string) => any;
    customStyles?: any;
    index: number;
    onMouseEnter?: (stageId: string) => void;
    onMouseLeave?: (stageId: string) => void;
};

export class StageHeaderChevron extends React.PureComponent<Props> {
    render() {
        return (
            <Draggable draggableId={this.props.stage.id} index={this.props.index}>
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <StageChevronContainer
                            onClick={this.props.onClick}
                            stage={this.props.stage}
                            hasShadow={true}
                            includeConfidence={true}
                            includeDescriptionIcon={true}
                            onMouseEnter={this.handleMouseEnter}
                            onMouseLeave={this.handleMouseLeave}
                            customStyles={{marginRight: this.props.isLastChild ? 0 : 8}}
                            isFirstChild={this.props.isFirstChild}
                            isLastChild={this.props.isLastChild}
                        />
                    </div>
                )}
            </Draggable>
        );
    }

    handleMouseEnter = () => {
        if (this.props.onMouseEnter) {
            this.props.onMouseEnter(this.props.stage.id);
        }
    };

    handleMouseLeave = () => {
        if (this.props.onMouseLeave) {
            this.props.onMouseLeave(this.props.stage.id);
        }
    };
}
